const STORAGE_PREFIX = 'batak_';

const readQuery = () => {
    const params = new URLSearchParams(window.location.search || '');
    const pick = (...keys) => {
        for (const key of keys) {
            const value = params.get(key);
            if (value && value.trim()) return value.trim();
        }
        return '';
    };

    return {
        userId: pick('userId', 'id', 'uuid'),
        id: pick('id', 'userId', 'uuid'),
        uuid: pick('uuid', 'userId', 'id'),
        playerName: pick('playerName', 'username', 'userName', 'name'),
        avatarUrl: pick('avatarUrl', 'avatar', 'photoUrl'),
        callerId: pick('callerId'),
        gender: pick('gender'),
        rating: pick('rating'),
        interests: pick('interests'),
        numericId: pick('id', 'numericId'),
        authToken: pick('authToken'),
        apiBaseUrl: pick('apiBaseUrl'),
        appBuild: pick('appBuild'),
        appPlatform: pick('appPlatform'),
        deviceId: pick('deviceId'),
        // Aktif kozmetik çerçevenin statik görseli; avatar gibi masaya yayınlanır.
        frameUrl: pick('frameUrl'),
    };
};

const getStored = (key) => {
    try {
        return window.localStorage.getItem(`${STORAGE_PREFIX}${key}`) || '';
    } catch (_) {
        return '';
    }
};

const setStored = (key, value) => {
    if (!value) return;
    try {
        window.localStorage.setItem(`${STORAGE_PREFIX}${key}`, value);
    } catch (_) {}
};



const randomUserId = () => `u_${Math.random().toString(36).slice(2, 10)}`;
// BT Fun backend is btfservice. Older app builds (and localStorage copies they
// left behind) still carry the TCF host as apiBaseUrl — rewrite it so join /
// friends / invites hit the right backend until those builds are replaced.
const toBtfApiBase = (u) => String(u || '').replace(/^(https?:\/\/)(tcfservice\.telpass-ltd\.live|shuffly\.chat)(?=[\/?#]|$)/i, '$1btfservice.telpass-ltd.live');

export const getNativeProfile = () => {
    const query = readQuery();
    const userId = query.userId || getStored('userId') || randomUserId();
    const id = query.id || getStored('id') || userId;
    const uuid = query.uuid || getStored('uuid') || userId;
    const playerName = query.playerName || getStored('playerName') || '';
    const avatarUrl = query.avatarUrl || getStored('avatarUrl') || '';
    const callerId = query.callerId || getStored('callerId') || '';
    const gender = query.gender || getStored('gender') || '';
    const rating = parseFloat(query.rating || getStored('rating')) || 0;
    const numericId = query.numericId || getStored('numericId') || id;
    const authToken = _freshAuthToken || query.authToken || getStored('authToken') || '';
    const apiBaseUrl = toBtfApiBase(query.apiBaseUrl || getStored('apiBaseUrl') || '');
    // Sürüm/cihaz kimliği — yalnız URL'den; saklanmaz (eski değer taşımasın).
    const appBuild = query.appBuild || '';
    const appPlatform = query.appPlatform || '';
    const deviceId = query.deviceId || '';
    const frameUrl = query.frameUrl || '';

    let interests = [];
    try { interests = JSON.parse(query.interests || getStored('interests') || '[]'); } catch (_) {}

    setStored('userId', userId);
    setStored('id', id);
    setStored('uuid', uuid);
    setStored('playerName', playerName);
    setStored('avatarUrl', avatarUrl);
    setStored('callerId', callerId);
    setStored('gender', gender);
    if (rating) setStored('rating', String(rating));
    setStored('numericId', numericId);
    if (authToken) setStored('authToken', authToken);
    if (apiBaseUrl) setStored('apiBaseUrl', apiBaseUrl);
    if (interests.length) setStored('interests', JSON.stringify(interests));

    return { userId, id, uuid, playerName, avatarUrl, callerId, gender, rating, interests, numericId, authToken, apiBaseUrl, appBuild, appPlatform, deviceId, frameUrl };
};

// Backend'e giden HER isteğin header'ları tek yerden (FourColors 0a32648 ile
// aynı düzen). Flutter'ın Dio interceptor'ı X-App-Build / X-App-Platform /
// X-Device-Id'yi her istekte gönderiyor; WebView kendi fetch'lerini yaptığı
// için o interceptor'ın dışında kalıyor ve değerleri açılış URL'sinden
// (appBuild / appPlatform / deviceId) taşımak zorunda. Zorunlu-güncelleme
// geçidi bu header'lar yoksa isteği 426 UPDATE_REQUIRED ile reddediyor, ban
// geçidi cihaz banlarını X-Device-Id ile eşliyor. Boş değer GÖNDERİLMEZ.
export const authHeaders = (p, extra) => {
    const h = extra ? { ...extra } : {};
    if (p.authToken) h['Authorization'] = 'Bearer ' + p.authToken;
    if (p.appBuild) h['X-App-Build'] = String(p.appBuild);
    if (p.appPlatform) h['X-App-Platform'] = String(p.appPlatform);
    if (p.deviceId) h['X-Device-Id'] = String(p.deviceId);
    h['Accept'] = 'application/json';
    return h;
};

// ── 401 → Flutter'dan taze token → isteği bir kez tekrarla ───────────────────
// Webview URL'ine gömülen token oyun sırasında ölebiliyor: JWT süresi dolar ya
// da backend'in oturum bağlama geçidi (SESSION_UNBOUND) sid'siz eski token'ı
// reddeder. Uygulama her 401'de sessizce refresh yapıp isteği tekrarlıyor
// (TokenRefreshInterceptor); bu üçlü aynı zinciri oyuna verir. Eski app
// build'lerinde requestAuthToken handler'ı yok → timeout → eski davranış (401).
let _freshAuthToken = '';
let _tokenWaiters = null;

const _applyAuthToken = (tok) => {
    if (tok) {
        _freshAuthToken = String(tok);
        setStored('authToken', _freshAuthToken);
    }
    const waiters = _tokenWaiters;
    _tokenWaiters = null;
    if (waiters) waiters.forEach((fn) => fn(tok ? String(tok) : null));
};

const requestFreshToken = () => new Promise((resolve) => {
    const hasBridge = !!(window.flutter_inappwebview?.callHandler || window.FlutterBridge?.postMessage);
    if (!hasBridge) return resolve(null);
    const first = !_tokenWaiters;
    if (first) _tokenWaiters = [];
    let done = false;
    const finish = (tok) => { if (done) return; done = true; clearTimeout(timer); resolve(tok); };
    const timer = setTimeout(() => finish(null), 6000);
    _tokenWaiters.push(finish);
    if (first) postNative('requestAuthToken', {});
});

// Header'lar her denemede yeniden kurulur ki retry taze token'ı kullansın.
export const authedFetch = async (url, opts = {}) => {
    const send = () => fetch(url, { ...opts, headers: authHeaders(getNativeProfile(), opts.headers) });
    let res = await send();
    if (res.status === 401) {
        const tok = await requestFreshToken();
        if (tok) res = await send();
    }
    return res;
};

// ── Flutter bridge ───────────────────────────────────────────────────────────
export const postNative = (handler, payload = {}) => {
    try {
        if (window.flutter_inappwebview?.callHandler) {
            window.flutter_inappwebview.callHandler(handler, payload);
            return;
        }
    } catch (_) {}

    try {
        if (window.FlutterBridge?.postMessage) {
            window.FlutterBridge.postMessage(JSON.stringify({ handler, payload }));
        }
    } catch (_) {}
};

// ── Voice ────────────────────────────────────────────────────────────────────
export const startVoice = (roomId) => {
    if (!roomId) return;
    postNative('startVoice', {
        roomId,
        userId: getNativeProfile().userId,
    });
};

export const stopVoice = () => {
    postNative('stopVoice', {});
};

export const toggleMic = (action) => {
    postNative('toggleMic', { action });
};

export const muteRemoteUser = (userId, mute) => {
    if (!userId) return;
    postNative('muteRemoteUser', { userId, mute });
};

export const subscribeSpeakingUpdates = (callback) => {
    const handler = (userIds) => {
        callback(new Set(Array.isArray(userIds) ? userIds : []));
    };

    window.SHUFFLY_onSpeakingUpdate = handler;
    window.BATAK_onSpeakingUpdate = handler;

    return () => {
        if (window.SHUFFLY_onSpeakingUpdate === handler) {
            delete window.SHUFFLY_onSpeakingUpdate;
        }
        if (window.BATAK_onSpeakingUpdate === handler) {
            delete window.BATAK_onSpeakingUpdate;
        }
    };
};

// ── Coin balance ─────────────────────────────────────────────────────────────
export const fetchBalance = async () => {
    const p = getNativeProfile();
    if (!p.callerId) return null;
    try {
        const res = await fetch('/api/balance?callerId=' + encodeURIComponent(p.callerId));
        if (!res.ok) return null;
        const data = await res.json();
        return data.balance;
    } catch (e) {
        return null;
    }
};

export const joinGame = async (idempotencyKey) => {
    const p = getNativeProfile();
    if (!p.authToken || !p.apiBaseUrl) return { success: false, message: 'no auth' };
    try {
        const res = await authedFetch(p.apiBaseUrl + '/api/games/batak/join', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ idempotencyKey, app_page: 'game' }),
        });
        const data = await res.json();
        return { success: res.ok, data, statusCode: res.status };
    } catch (e) {
        return { success: false, message: e.message };
    }
};

// ── Friend request API ───────────────────────────────────────────────────────
const _profile = () => getNativeProfile();

export const sendFriendRequest = async (socket, targetCallerId, message, targetGameUserId) => {
    const p = _profile();

    if (!p.authToken || !p.apiBaseUrl) {
        // Fallback: delegate to Flutter
        postNative('sendFriendRequest', { targetUserId: targetCallerId, message: message || '' });
        if (socket && targetGameUserId) {
            socket.emit('friendRequestNotify', {
                targetUserId: targetGameUserId,
                fromCallerId: p.callerId,
                fromPlayerName: p.playerName,
                fromAvatarUrl: p.avatarUrl,
            });
        }
        return { success: false, message: 'no authToken' };
    }

    try {
        const res = await authedFetch(p.apiBaseUrl + '/v1/friend-requests', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ targetUserId: targetCallerId, message: message || '' }),
        });
        const text = await res.text();
        let data;
        try { data = JSON.parse(text); } catch (_) { data = { raw: text }; }

        if (res.ok && socket && targetGameUserId) {
            socket.emit('friendRequestNotify', {
                targetUserId: targetGameUserId,
                fromCallerId: p.callerId,
                fromPlayerName: p.playerName,
                fromAvatarUrl: p.avatarUrl,
            });
        }
        return { success: res.ok, data, statusCode: res.status };
    } catch (e) {
        return { success: false, message: e.message };
    }
};

export const acceptFriendRequest = async (fromCallerId) => {
    const p = _profile();
    if (p.authToken && p.apiBaseUrl) {
        try {
            const res = await authedFetch(p.apiBaseUrl + '/v1/friend-requests/' + fromCallerId + '/accept', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            });
            return { success: res.ok };
        } catch (e) {
            return { success: false };
        }
    }
    postNative('acceptFriendRequest', { fromUserId: fromCallerId });
    return { success: false, message: 'delegated to native' };
};

export const rejectFriendRequest = async (fromCallerId) => {
    const p = _profile();
    if (p.authToken && p.apiBaseUrl) {
        try {
            const res = await authedFetch(p.apiBaseUrl + '/v1/friend-requests/' + fromCallerId + '/reject', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            });
            return { success: res.ok };
        } catch (e) {
            return { success: false };
        }
    }
    postNative('rejectFriendRequest', { fromUserId: fromCallerId });
    return { success: false, message: 'delegated to native' };
};

// ── Oyun davetleri (v1/friends + v1/game-invitations) ────────────────────────
// Backend'in döndürdüğü göreli medya yollarını apiBaseUrl'e göre mutlaklaştır
export const resolveMediaUrl = (raw) => {
    const s = String(raw || '').trim();
    if (!s) return '';
    const lower = s.toLowerCase();
    if (lower.startsWith('http://') || lower.startsWith('https://') || lower.startsWith('data:')) return s;
    const base = _profile().apiBaseUrl;
    if (!base) return s;
    return base.replace(/\/+$/, '') + (s.startsWith('/') ? s : '/' + s);
};

// Arkadaş listesi (cursor'lı sayfalama) → [{callerId, name, avatarUrl}]
export const fetchFriendsList = async (maxItems = 500) => {
    const p = _profile();
    if (!p.authToken || !p.apiBaseUrl) return { success: false, message: 'no auth', friends: [] };
    const friends = [];
    let cursor = '';
    try {
        while (friends.length < maxItems) {
            let url = p.apiBaseUrl + '/v1/friends?limit=' + Math.min(100, maxItems - friends.length);
            if (cursor) url += '&cursor=' + encodeURIComponent(cursor);
            const res = await authedFetch(url, {});
            if (!res.ok) return { success: false, statusCode: res.status, friends };
            const body = await res.json();
            (body.items || []).forEach((row) => {
                if (!row || !row.userId) return;
                friends.push({
                    // Sosyal graf userId'si == users.callerid (davet API'sinin kimliği)
                    callerId: String(row.userId),
                    name: String(row.alias || row.displayName || 'Joueur'),
                    avatarUrl: resolveMediaUrl(row.avatarUrl || ''),
                });
            });
            if (!body.hasMore || !body.nextCursor) break;
            cursor = String(body.nextCursor);
        }
        return { success: true, friends };
    } catch (e) {
        return { success: false, message: e.message, friends };
    }
};

// Canlı davetler (iki yön): { incoming: [...], outgoing: [...] }
export const fetchGameInvitations = async () => {
    const p = _profile();
    if (!p.authToken || !p.apiBaseUrl) return { success: false, message: 'no auth' };
    try {
        const res = await authedFetch(p.apiBaseUrl + '/v1/game-invitations', {});
        const text = await res.text();
        let data; try { data = JSON.parse(text); } catch (_) { data = { raw: text }; }
        return { success: res.ok, data, statusCode: res.status };
    } catch (e) {
        return { success: false, message: e.message };
    }
};

// Davet: oturuyorsa kendi masasına (roomId), oturmuyorsa backend'in ürettiği
// yeni özel masaya. Arkadaşlık/ban/limit kontrolleri sunucuda. Aynı arkadaşa
// tekrar göndermek bekleyen daveti tazeler (yeni süre + yeniden push).
export const sendGameInvite = async (inviteeCallerId, roomId) => {
    const p = _profile();
    if (!p.authToken || !p.apiBaseUrl) return { success: false, message: 'no auth' };
    try {
        const res = await authedFetch(p.apiBaseUrl + '/v1/game-invitations', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                gameType: 'batak',
                inviteeCallerIds: [inviteeCallerId],
                ...(roomId ? { roomId } : {}),
            }),
        });
        const text = await res.text();
        let data; try { data = JSON.parse(text); } catch (_) { data = { raw: text }; }
        return { success: res.ok, data, statusCode: res.status };
    } catch (e) {
        return { success: false, message: e.message };
    }
};

// Davet kabulüyle açılış parametreleri (uygulamadan veya oyun içi kabulden):
// joinRoomId → ana sayfada otomatik oturma; inviteFromUserId → kabul cevabının
// lobi soketinden davet edene iletilmesi.
export const getInviteBoot = () => {
    const params = new URLSearchParams(window.location.search || '');
    return {
        joinRoomId: (params.get('joinRoomId') || '').trim(),
        inviteFromUserId: (params.get('inviteFromUserId') || '').trim(),
    };
};

// ── Davet masası (inv_) ──────────────────────────────────────────────────────
// SPA içinde navigate() sorguyu siler; davet parametreleri modül yüklenirken
// bir kez okunur.
const _bootParams = new URLSearchParams(window.location.search || '');
// Yeni uygulama davet bildirimlerini kendisi gösterir, web dialogu çıkmaz. Eski
// sürümler bu parametreyi göndermez ve web dialogunu kullanmaya devam eder.
export const nativeInvites = _bootParams.get('nativeInvites') === '1';
// Ham cihaz kimliği: X-Device-Id başlığına giden değerin aynısı.
const _bootDeviceId = (_bootParams.get('deviceId') || '').trim();
// Davet kabulüyle açıldıysa davetin kimliği: masaya oturulamazsa backend'e
// join-failed bildirilir (kabul eden ama oturamayan oranı buradan ölçülür).
let _invitationId = (_bootParams.get('invitationId') || '').trim();

export const isInviteRoomId = (roomId) => String(roomId || '').startsWith('inv_');

// Davet masasında sunucu oyuncuyu kendi JWT'si ve cihazıyla doğrular; diğer
// masalarda ikisi de sokete hiç konmaz.
export const inviteJoinProof = (roomId) => {
    if (!isInviteRoomId(roomId)) return {};
    const p = getNativeProfile();
    return { authToken: p.authToken || '', deviceId: p.deviceId || _bootDeviceId };
};

// Oturuldu ya da oyun başladı: artık "oturamadı" bildirimi yok.
export const clearInvitationId = () => { _invitationId = ''; };

// Davet kabul edildi ama masaya oturulamadı: koltuk yarışının ölçüsü. Yalnızca
// bir kez, yalnızca masa hataları için.
export const reportInviteJoinFailed = (err) => {
    const id = _invitationId;
    if (!id || !err || !['room_closed', 'game_started', 'room_full'].includes(err.code)) return;
    _invitationId = '';
    const p = getNativeProfile();
    if (!p.authToken || !p.apiBaseUrl) return;
    authedFetch(p.apiBaseUrl + '/v1/game-invitations/' + encodeURIComponent(id) + '/join-failed', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reason: err.code }),
    }).catch(() => {});
};

// ── Friend list (injected from Flutter) ──────────────────────────────────────
window._batakFriendSet = new Set();

const _applyFriendList = (friends) => {
    window._batakFriendSet = new Set((friends || []).map(f => f.userId));
};

window.SHUFFLY_setFriendList = _applyFriendList;
window.BATAK_setFriendList = _applyFriendList;

export const isFriend = (callerId) => window._batakFriendSet.has(callerId);

// ── Native event callbacks ───────────────────────────────────────────────────
// Flutter: window.BATAK_onNativeEvent / SHUFFLY_onNativeEvent({ handler, payload }).
// Davet olayları: inviteJoin { roomId, authToken }, inviteRelease {}.
const _nativeListeners = new Set();
export const subscribeNativeEvents = (fn) => {
    _nativeListeners.add(fn);
    return () => _nativeListeners.delete(fn);
};

const _onNativeEvent = (data) => {
    if (!data) return;
    // 401 sonrası istenen taze token (requestAuthToken cevabı)
    if (data.handler === 'authToken') _applyAuthToken(data.payload?.token);
    // Oyun uzun süredir açıksa URL'deki token dolmuş olabilir: davet masasına
    // oturuş bu token'la doğrulanır.
    if (data.handler === 'inviteJoin' && data.payload?.authToken) _applyAuthToken(data.payload.authToken);
    if (data.handler === 'friendRequestSent' && data.payload?.success) {
        window._batakFriendSet.add(data.payload.targetUserId);
    }
    if (data.handler === 'friendRequestAccepted' && data.payload?.success) {
        window._batakFriendSet.add(data.payload.fromUserId);
    }
    _nativeListeners.forEach((fn) => {
        try { fn(data); } catch (e) { console.error('[batak native event]', e); }
    });
};

window.SHUFFLY_onNativeEvent = _onNativeEvent;
window.BATAK_onNativeEvent = _onNativeEvent;

window.addEventListener('pagehide', stopVoice);
